import React, { useState, useEffect, useContext } from 'react';
import { useHistory } from "react-router-dom";
import QRCode from 'react-qr-code';
import { SuccessContent, Total } from './style';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { FaCopy, FaCheckCircle } from 'react-icons/fa';
import { useDate } from "../../../hooks/useDate";
import { toast } from "react-toastify";
import { AuthContext } from '../../../context/Auth/AuthContext';
import { SocketContext } from '../../../context/Socket/SocketContext';

function CheckoutSuccess(props) {

  const { pix } = props;
  const socketManager = useContext(SocketContext);
  const [pixString,] = useState(pix?.qrcode?.qrcode || '');
  const [stripeURL,] = useState(pix.stripeURL);
  const [asaasURL,] = useState(pix.asaasURL);
  const [mercadopagoURL,] = useState(pix.mercadopagoURL);
  const [valorext,] = useState(pix.valorext);
  const [copied, setCopied] = useState(false);
  const [paymentConfirmed, setPaymentConfirmed] = useState(false);
  const [dueDateConfirmed, setDueDateConfirmed] = useState(null);
  const [countdown, setCountdown] = useState(7);
  const history = useHistory();

  const { dateToClient } = useDate();
  const { user, socket } = useContext(AuthContext);

  const companyId = user.companyId;

  useEffect(() => {
    const onCompanyPayment = (data) => {
      if (data.action === "CONCLUIDA") {
        setDueDateConfirmed(data.company?.dueDate || null);
        setPaymentConfirmed(true);
        setCountdown(7);
      }
    };
    socket.on(`company-${companyId}-payment`, onCompanyPayment);

    return () => {
      socket.off(`company-${companyId}-payment`, onCompanyPayment);
    };
  }, [socket, companyId]);

  useEffect(() => {
    if (!paymentConfirmed) return;
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          history.push("/");
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, [paymentConfirmed, history]);

  const handleCopyQR = () => {
    setTimeout(() => {
      setCopied(false);
    }, 1 * 1000);
    setCopied(true);
  };

  return (
    <React.Fragment>
      {paymentConfirmed && (
        <div style={{
          position: 'fixed',
          top: 0, left: 0, right: 0, bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.7)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 9999,
        }}>
          <div style={{
            background: '#fff',
            borderRadius: 4,
            padding: '40px 48px',
            textAlign: 'center',
            maxWidth: 400,
            boxShadow: '0 8px 32px rgba(0,0,0,0.2)',
          }}>
            <div style={{ fontSize: 56, marginBottom: 8 }}>✅</div>
            <h2 style={{ margin: '0 0 8px', color: '#2e7d32', fontFamily: "'Inter', sans-serif" }}>
              Pagamento recebido!
            </h2>
            {dueDateConfirmed && (
              <p style={{ margin: '0 0 16px', color: '#555', fontFamily: "'Inter', sans-serif" }}>
                Sua licença foi renovada até {dateToClient(dueDateConfirmed)}.
              </p>
            )}
            {/* {f && (
              <p style={{ margin: '0 0 16px', color: '#555', fontFamily: "'Inter', sans-serif" }}>
                Sua licença foi renovada até {y(f)}.
              </p>
            )} */}
            <p style={{ margin: '0 0 20px', color: '#777', fontFamily: "'Inter', sans-serif", fontSize: 14 }}>
              Redirecionando em <strong style={{ fontSize: 18, color: '#1976d2' }}>{countdown}</strong> segundo{countdown !== 1 ? 's' : ''}...
            </p>
            <button
              onClick={() => history.push("/")}
              type="button"
              style={{
                backgroundColor: '#1976d2',
                color: '#fff',
                border: 'none',
                borderRadius: 4,
                padding: '10px 28px',
                fontSize: 15,
                fontFamily: "'Inter', sans-serif",
                fontWeight: 500,
                cursor: 'pointer',
                letterSpacing: '0.02857em',
                textTransform: 'uppercase',
              }}
            >
              Ir para o sistema agora
            </button>
          </div>
        </div>
      )}
      <Total>
        <p><span>TOTAL</span></p>
        <strong>R$ {valorext.toLocaleString('pt-br', { minimumFractionDigits: 2 })}</strong>
      </Total>



      <SuccessContent>

        {pixString && (
          <>

            <QRCode value={pixString} />
            <CopyToClipboard text={pixString} onCopy={handleCopyQR}>
              <button className="copy-button" type="button">
                {copied ? (
                  <>
                    <span>Copiado</span>
                    <FaCheckCircle size={18} />
                  </>
                ) : (
                  <>
                    <span>Copiar código QR PIX</span>
                    <FaCopy size={18} />
                  </>
                )}
              </button>
            </CopyToClipboard>
            <span>
              Para finalizar, basta realizar o pagamento escaneando ou colando o
              código Pix acima ou escolha Pagar com Cartão de Crédito abaixo.
            </span>
            <span><p> </p></span>

          </>
        )}

        {stripeURL && (
          <>
            <button onClick={() => window.open(stripeURL, '_blank')} type="button"

              style={{
                color: '#3c6afb',
                background: '#ffffff',
                border: '1px solid #3c6afb',
                padding: '6px 16px',
                fontSize: '18px',
                minWidth: '50%',
                boxSizing: 'border-box',
                transition: 'background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
                fontFamily: "'Inter', sans-serif",
                fontWeight: '500',
                lineHeight: '1.75',
                borderRadius: '4px',
                letterSpacing: '0.02857em',
                textTransform: 'uppercase',
                // Add any additional styles here
              }}

            >
              Pagar com Cartão de Crédito
            </button>
            <span><p> </p></span>
          </>
        )}


        {mercadopagoURL && (
          <>
            <button onClick={() => window.open(mercadopagoURL, '_blank')} type="button"

              style={{
                color: '#3c6afb',
                background: '#ffffff',
                border: '1px solid #3c6afb',
                padding: '6px 16px',
                fontSize: '18px',
                minWidth: '50%',
                boxSizing: 'border-box',
                transition: 'background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
                fontFamily: "'Inter', sans-serif",
                fontWeight: '500',
                lineHeight: '1.75',
                borderRadius: '4px',
                letterSpacing: '0.02857em',
                textTransform: 'uppercase',
                // Add any additional styles here
              }}

            >
              Pagar com MercadoPago
            </button>
            <span><p> </p></span>
          </>
        )}

        {asaasURL && (
          <>
            <button onClick={() => window.open(asaasURL, '_blank')} type="button"

              style={{
                color: '#3c6afb',
                background: '#ffffff',
                border: '1px solid #3c6afb',
                padding: '6px 16px',
                fontSize: '18px',
                minWidth: '50%',
                boxSizing: 'border-box',
                transition: 'background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
                fontFamily: "'Inter', sans-serif",
                fontWeight: '500',
                lineHeight: '1.75',
                borderRadius: '4px',
                letterSpacing: '0.02857em',
                textTransform: 'uppercase',
                // Add any additional styles here
              }}

            >
              Pagar com Asaas
            </button>
            <span><p> </p></span>
          </>
        )}


      </SuccessContent>
    </React.Fragment>
  );
}

export default CheckoutSuccess;
